const COUNTRY_CURRENCY_CONFIG = {
  NZ: { currency: 'NZD', locale: 'en-NZ' },
  AU: { currency: 'AUD', locale: 'en-AU' },
  US: { currency: 'USD', locale: 'en-US' },
  GB: { currency: 'GBP', locale: 'en-GB' },
  GI: { currency: 'GIP', locale: 'en-GI' },
  CA: { currency: 'CAD', locale: 'en-CA' }
};

export function getCurrencyConfig(country) {
  return COUNTRY_CURRENCY_CONFIG[country] || COUNTRY_CURRENCY_CONFIG.NZ;
}

export function createCurrencyFormatter(country) {
  const config = getCurrencyConfig(country);
  const formatter = new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return (amount) => {
    if (amount == null || isNaN(amount)) return formatter.format(0);
    return formatter.format(amount);
  };
}
